import { DatasourceTypeType } from 'Services/api/v2';
import AmkMonitor from './AMK';
import IridiumMonitor from './Iridium';
import VisualCrossingMonitor from './VisualCrossing';

// AMK на русской раскладке
type MonitorsByTypeType = {
  [key: string]: () => JSX.Element,
  АМК: () => JSX.Element,
  IRIDIUM: () => JSX.Element
}
export const monitorsByType: MonitorsByTypeType = {
  АМК: AmkMonitor,
  IRIDIUM: IridiumMonitor,
  'VISUALCROSSING.COM': VisualCrossingMonitor,
};

export function getMonitorForDatasourceType(datasourceType: DatasourceTypeType) {
  if (!datasourceType?.shortName) return undefined;
  return monitorsByType[datasourceType.shortName.toUpperCase()];
}

export function hasMonitorForDatasourceType(datasourceType: DatasourceTypeType) {
  return hasMonitorForDatasourceTypeByName(datasourceType?.shortName);
}

export function hasMonitorForDatasourceTypeByName(name: string) {
  return Object.keys(monitorsByType).includes(name.toUpperCase());
}
